const column = [
  {
    name:'首页',
    to:'/',
    type:1,//栏目type 1点击页内跳转 2栏目归类，下有子栏目 3打开新页面跳转
    children:[
      {
        name:'数字经济系',
        to:'/desc',
        type:1,
        params:{
          id:56
        },
      },
      {
        name:'智能控制系',
        to:'/desc',
        type:1,
        params:{
          id:75
        },
      },
      {
        name:'文创设计系',
        to:'/desc',
        type:1,
        params:{
          id:76
        },
      },
    ],
    params:{},
    img:'',
    introduce:''
  },

  {
    name:'学校概况',
    to:'/evn/content?id=0&pid=1',
    type:1,
    img:'b01.jpg',
    introduce:'坚持“高端引领、双轮驱动、融合发展、质量强校”的办学方针',
    children:[
      {
        name:'学校简介',
        to:'/evn/content',
        type:1,
        params:{
          id:8
        },
      },
      {
        name:'学校领导',
        to:'/evn/list',
        type:2,
        params:{
          id:11,
          template:'teacher'
        },
      },
      {
        name:'组织机构',
        to:'/evn/content',
        type:1,
        params:{
          id:7
        },
      },
      //   name:'学校宣传片',
      //     id:16
      {
        name:'校园风光',
        to:'/evn/list',
        type:2,
        params:{
          id:17,
          template:'nev'
        },
      },
      //   name:'办学理念',
      //     id:0
      //   name:'规章制度',
      //     id:14,
      {
        name:'交通指引',
        to:'/evn/content',
        type:1,
        params:{
          id:151
        },
      }
    ],
  },
  {
    name:'学校动态',
    to:'/evn/list?id=0&pid=2',
    type:1,
    img:'b02.jpg',
    introduce:'坚持“高端引领、双轮驱动、融合发展、质量强校”的办学方针',
    children:[
      {
        name:'校园新闻',
        to:'/evn/list',
        type:2,
        params:{
          id:68,
          template:'xnews'
        },
      },
      {
        name:'通知公告',
        to:'/evn/list',
        type:2,
        params:{
          id:69,
          template:'notice'
        },
      },
      //   name:'媒体聚焦',
      //     id:20,
    ],
  },
  {
    name:'党群风采',
    to:'/evn/list?id=0&pid=3',
    type:1,
    img:'b03.jpg',
    introduce:'坚持“高端引领、双轮驱动、融合发展、质量强校”的办学方针',
    children:[
      {
        name:'党群风采',
        to:'/evn/list',
        type:2,
        params:{
          id:21,
          template:'media'
        },
      },
    ],
  },
  {
    name:'教学科研',
    to:'/evn/list?id=0&pid=4',
    type:1,
    img:'b04.jpg',
    introduce:'坚持“高端引领、双轮驱动、融合发展、质量强校”的办学方针',
    children:[
      {
        name:'教学科研',
        to:'/evn/list',
        type:2,
        params:{
          id:22,
          template:'media'
        },
      },
      {
        name:'专业介绍',
        to:'/evn/list',
        type:2,
        params:{
          id:78,
          template:'zhuan'
        },
      },
    ],
  },
  {
    name:'招生就业',
    // to:'/enroll',
    to:'/evn/list?id=0&pid=5',
    type:1,//栏目type 1点击页内跳转 2栏目归类，下有子栏目 3打开新页面跳转
    children:[
      {
        name:'招生动态',
        to:'/evn/list',
        type:2,
        params:{
          id:71,
          template:'media'
        },
      },
      {
        name:'联系我们',
        to:'/evn/content',
        type:1,
        params:{
          id:293
        },
      },
    ],
    params:{},
    img:'b05.jpg',
    introduce:''
  },
  {
    name:'学工在线',
    to:'/evn/list?id=0&pid=6',
    type:1,//2
    img:'b06.jpg',
    introduce:'坚持“高端引领、双轮驱动、融合发展、质量强校”的办学方针',
    children:[
      {
        name:'学工在线',
        to:'/evn/list',
        type:2,
        params:{
          id:33,
          template:'media'
        },
      },
      {
        name:'学生风采',
        to:'/evn/list',
        type:2,
        params:{
          id:74,
          template:'media'
        },
      },
      // {
      //   name:'院系风采',
      //     id:34,
      //   name:'社团风采',
      //     id:35,
      //   name:'院校文化',
      //     id:36,
      //   name:'党团建设',
      //     id:37,
      //   name:'规章制度',
      //     id:38,
      //   name:'心理健康',
      //     id:39,
      //   name:'校园之星',
      //     id:40,
    ],
  },
  {
    name:'社会服务',
    to:'/evn/list?id=0&pid=7',
    type:1,
    img:'b07.jpg',
    introduce:'坚持“高端引领、双轮驱动、融合发展、质量强校”的办学方针',
    children:[
      {
        name:'社会服务',
        to:'/evn/list',
        type:2,
        params:{
          id:41,
          template:'media'
        },
      },
      //   name:'技能鉴定'
      //     id:42
      //   name:'公共实训'
      //     id:43,
      //   name:'技师研修'
      //     id:44,
      //   name:'学历提升'
      //     id:45
      //   name:'创新孵化'
      //     id:46
      //   name:'竞赛集训'
      //     id:47,
      //   name:'产教融合'
      //     id:48,
      //   name:'实训实习',
      //     id:67,
    ],
  },
  // {
  //   name:'水蕴匠心',
  //   to:'/',
  //   type:1,//栏目type 1点击页内跳转 2栏目归类，下有子栏目 3打开新页面跳转
  //   children:[],
  //   params:{},
  //   img:'b08.jpg',
  //   introduce:''
  // },
  {
    name:'公共服务',
    to:'',
    type:9,
    img:'',
    introduce:'坚持“高端引领、双轮驱动、融合发展、质量强校”的办学方针',
    children:[
      {
        name:'学期日历',
        to:'/evn/list',
        type:2,
        params:{
          id:61,
          template:'media'
        },
      },
    ],
  },
  {
    name:'宣传信息',
    to:'',
    type:9,
    img:'',
    introduce:'坚持“高端引领、双轮驱动、融合发展、质量强校”的办学方针',
    children:[
      {
        name:'宣传视频',
        to:'/desc',
        type:1,
        params:{
          id:295
        },
      },
    ],
  },
];

const enrollColumn = [
  {
    name:'本站首页',
    to:'/enroll/index',
    type:1,//栏目type 1点击页内跳转 2栏目归类，下有子栏目 3打开新页面跳转
    children:[],
    params:{},
    img:'',
    introduce:''
  },
  {
    name:'学校概况',
    to:'/evn/content?id=0&pid=1',
    type:1,
    children:[],
    img:'',
    introduce:'',
    params:{
      id:0
    },
  },
  {
    name:'招生信息',
    to:'',
    type:2,
    img:'',
    introduce:'',
    status:0,
    params:{
      id:0
    },
    children:[
      {
        name:'招生计划',
        to:'/enroll/article/list',
        type:1,
        params:{
          category_id:3
        },
      },
      {
        name:'收费一览',
        to:'/enroll/article/content',
        type:1,
        params:{
          article_id:18
        },
      },
      {
        name:'录取程序',
        to:'/enroll/article/content',
        type:1,
        params:{
          article_id:2
        },
      },
      {
        name:'证书样本',
        to:'/enroll/article/content',
        type:1,
        params:{
          article_id:16
        },
      },
    ],
  },
  {
    name:'招生动态',
    to:'/enroll/article/list',
    type:1,
    img:'',
    introduce:'',
    children:[],
    params:{
      category_id:7
    },
  },
  {
    name:'网上报名',
    to:'/sign',
    type:3,
    img:'',
    introduce:'',
    children:[],
    params:{
      category_id:8
    },
  },
  {
    name:'常见问答',
    to:'/enroll/article/list',
    type:1,
    img:'',
    introduce:'',
    children:[],
    params:{
      category_id:9
    },
  },
  {
    name:'资料下载',
    to:'/enroll/article/list',
    type:1,
    img:'',
    introduce:'',
    children:[],
    params:{
      category_id:10
    },
  },
  {
    name:'联系我们',
    to:'/enroll/article/content',
    type:1,
    img:'',
    introduce:'',
    children:[],
    params:{
      article_id:13
    },
  },
  {
    name:'学校首页',
    to:'/',
    type:1,//栏目type 1点击页内跳转 2栏目归类，下有子栏目 3打开新页面跳转
    children:[],
    params:{
    },
    img:'',
    introduce:''
  },
];
export default {
  column,
  enrollColumn
}



// WEBPACK FOOTER //
// ./src/utils/params.js